import { Flex, Tooltip, useMantineTheme } from '@mantine/core';
import { FilterTargetLabel } from '@repo/common/components/Filter/FilterTarget/FilterTargetLabel';
import { Button, Text } from '@repo/foundations';
import { observer } from 'mobx-react-lite';
import type { EditBlockStore } from '../../store';
import { getEditActionLabel } from '../../utils';

export interface AiEditActionProps {
	store: EditBlockStore;
	actionSearchKey: string;
}

export const AiEditAction = observer(
	({ store, actionSearchKey }: AiEditActionProps) => {
		const theme = useMantineTheme();

		const editAction = store.editActions.get(actionSearchKey)!;
		const typeLabel = getEditActionLabel(editAction.editAction.type);

		return (
			<Button
				data-testid="ai-edit-action"
				size="sm"
				variant="default"
				sx={{
					'&:hover, &:focus': {
						backgroundColor: theme.other.getColor('fill/primary/default'),
					},
				}}
			>
				<Tooltip label="AI-generated filter. Remove the AI output action above to clear.">
					<Flex align="center" gap="xs">
						<FilterTargetLabel label={typeLabel} showChevron={false} />
						<Text color="text/secondary/default" size="xs">
							{'is generated by'}
						</Text>
						<Text size="xs">{'AI output'}</Text>
					</Flex>
				</Tooltip>
			</Button>
		);
	}
);
